"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _useTranslation = _interopRequireDefault(require("../TranslationProvider/useTranslation"));

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useTranslateLanguageLevel = function useTranslateLanguageLevel() {
  var t = (0, _useTranslation["default"])();
  return (0, _react.useCallback)(function () {
    var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    switch (level) {
      case 0.5:
        return t('language_level_not_spoken');

      case 1:
        return t('language_level_beginner');

      case 2:
        return t('language_level_academic');

      case 3:
        return t('language_level_professional');

      case 4:
        return t('language_level_bilingual');

      default:
        return t('language_level_none');
    }
  }, []);
};

__signature__(useTranslateLanguageLevel, "useTranslation{t}\nuseCallback{}", function () {
  return [_useTranslation["default"]];
});

var _default = useTranslateLanguageLevel;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useTranslateLanguageLevel, "useTranslateLanguageLevel", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Skills/useTranslateLanguageLevel.ts");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Skills/useTranslateLanguageLevel.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();